import { getAudioPublicToken } from "@/shared/api/songs";
import { getSongNotificationTarget, resolveNotificationRoute } from "./describe";
/**
 * Куда вести по уведомлению — АСИНХРОННО. Для МЕДИЙНЫХ уведомлений (видеообложка/
 * караоке/минус/WAV/продление) лениво резолвим публичный токен аудио и строим
 * deep-link публичного хаба `/song/{token}?…` (нужный таб / одиночное медиа) —
 * там табы уместны. Готовая песня и всё остальное (оплата/баланс/рефералы/
 * тексты/релизы) — синхронный маршрут кабинета. Ошибка резолва токена → фолбэк
 * на маршрут кабинета, чтобы клик не «терял» пользователя.
 */
export const resolveNotificationHref = async (n) => {
    const target = getSongNotificationTarget(n);
    if (target) {
        try {
            const token = await getAudioPublicToken(target.audioId);
            return `/song/${token}${target.query}`;
        }
        catch (e) {
            console.error("Failed to resolve song public token:", e);
            return resolveNotificationRoute(n);
        }
    }
    return resolveNotificationRoute(n);
};
/** Есть ли у уведомления куда переходить (для показа кнопки «Перейти»). */
export const hasNotificationTarget = (n) => getSongNotificationTarget(n) != null || resolveNotificationRoute(n) != null;
